import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'components/common/select'
import Typo from 'constants/typography'
import clsx from 'clsx'
import styles from './date-of-birth-select.scss'
import { DAYS_OPTIONS, MONTHS_OPTIONS, MONTHS_OPTIONS_NUM } from './const'

export const generateYearsOptions = (currentYear, startYear = 1923) => {
  if (currentYear === undefined || currentYear || null) {
    const generatedCurrentYear = new Date().getFullYear()
    return Array.from(
      { length: generatedCurrentYear - startYear + 1 },
      (_, index) => startYear + index,
    )
  }

  const yearsArray = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => startYear + index,
  )

  return yearsArray
}

const AuthDateOfBirthSelect = ({
  value,
  register,
  onChange,
  required,
  helperText,
  isDisabled,
}) => {
  const currentYear = new Date().getFullYear()
  const yearsOptions = generateYearsOptions(currentYear, 1923)

  const [year, setYear] = useState('')
  const [month, setMonth] = useState('')
  const [day, setDay] = useState('')

  useEffect(() => {
    if (value) {
      const [y, m, d] = value.split('-')
      setYear(y || '')

      const parsedMonth = MONTHS_OPTIONS.includes(m)
        ? m
        : MONTHS_OPTIONS[parseInt(m, 10) - 1]

      setMonth(parsedMonth || '')
      setDay(parseInt(d, 10).toString())
    }
  }, [value])

  const handleChange = (type, val) => {
    if (onChange) {
      const newDate = {
        day: type === 'day' ? val : day,
        month: type === 'month' ? val : month,
        year: type === 'year' ? val : year,
      }
      const birthMonth = MONTHS_OPTIONS_NUM[newDate.month]
      const fullBirthday = `${newDate.year}-${birthMonth}-${newDate.day}`
      onChange(fullBirthday)
    }
  }

  return (
    <div className="date-of-birth-select">
      <style jsx>{styles}</style>
      <div className={Typo.caption}>
        Date of Birth
        {required && (
          <span
            className={clsx(Typo.caption, 'date-of-birth-select__red-require')}
          >
            *
          </span>
        )}
      </div>

      <div className="date-of-birth-select__inputs">
        <Select
          required={required}
          name="date"
          className="date-of-birth-select__date"
          cy="auth__phone_prefix"
          inputRef={register ? register({ required: true }) : undefined}
          value={value ? day : undefined}
          disabled={isDisabled}
          onChange={(e) => handleChange('day', e.target.value)}
          defaultValue={onChange ? undefined : 1}
        >
          <option key="Day" value="">
            Day
          </option>
          {DAYS_OPTIONS.map((dayOpt) => (
            <option key={dayOpt} value={dayOpt}>
              {dayOpt}
            </option>
          ))}
        </Select>
        <Select
          required={required}
          fullWidth
          name="month"
          className="date-of-birth-select__month"
          cy="auth__phone_prefix"
          inputRef={register ? register({ required: true }) : undefined}
          value={value ? month : undefined}
          onChange={(e) => handleChange('month', e.target.value)}
          disabled={isDisabled}
          defaultValue={onChange ? undefined : 'Jan'}
        >
          <option key="Month" value="">
            Month
          </option>
          {MONTHS_OPTIONS.map((monthOpt) => (
            <option key={monthOpt} value={monthOpt}>
              {monthOpt}
            </option>
          ))}
        </Select>
        <Select
          required={required}
          fullWidth
          name="year"
          className="date-of-birth-select__year"
          cy="auth__phone_prefix"
          inputRef={register ? register({ required: true }) : undefined}
          value={value ? year : undefined}
          onChange={(e) => handleChange('year', e.target.value)}
          disabled={isDisabled}
          defaultValue={onChange ? undefined : 1990}
        >
          <option key="Year" value="">
            Year
          </option>
          {yearsOptions.map((yearOpt) => (
            <option key={yearOpt} value={yearOpt}>
              {yearOpt}
            </option>
          ))}
        </Select>
      </div>
      {helperText && (
        <span className={clsx(Typo.caption, 'date-of-birth-select__helper')}>
          {helperText}
        </span>
      )}
    </div>
  )
}

AuthDateOfBirthSelect.defaultProps = {
  register: null,
  onChange: null,
  helperText: '',
  required: false,
  value: undefined,
  isDisabled: false,
}

AuthDateOfBirthSelect.propTypes = {
  value: PropTypes.string,
  register: PropTypes.func,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  isDisabled: PropTypes.bool,
  helperText: PropTypes.string,
}

export default AuthDateOfBirthSelect
